module.exports = __webpack_public_path__ + "media/iphone2.ae1767bb.mp3";